import HttpService from "./htttp.service";

class AuthService {
	// authEndpoint = process.env.API_URL;

	login = async (payload) => {
		const loginEndpoint =
			window.location.hostname.split(".")[0] !== "localhost"
				? `https://${window.location.hostname.split(".")[0]}.helpmate.it/api/login/`
				: process.env.REACT_APP_API_URL_BACKEND + "/login/";
		return await HttpService.post(loginEndpoint, payload);
	};

	register = async (credentials) => {
		const registerEndpoint = "register";
		return await HttpService.post(registerEndpoint, credentials);
	};

	logout = async () => {
		const logoutEndpoint = "logout";
		return await HttpService.post(logoutEndpoint);
	};

	resetPassword = async (credentials) => {
		const resetPassword = "password-reset";
		return await HttpService.post(resetPassword, credentials);
	};

	getProfile = async () => {
		const getProfile = "me";
		return await HttpService.get(getProfile);
	};

	updateProfile = async (newInfo) => {
		const updateProfile = "me";
		return await HttpService.patch(updateProfile, newInfo);
	};
}

export default new AuthService();
